import type { Technique } from '../types';
import { VORONOI_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, toSVG, type VoronoiState } from './render';

export const voronoi: Technique<VoronoiState> = {
  id: 'voronoi',
  name: 'Voronoi',
  category: 'packing',
  description: 'Zellen um verteilte Ankerpunkte, wahlweise nur ausserhalb oder innerhalb der Buchstaben.',
  params: VORONOI_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  toSVG,
  elementCount,
};
